export default __webpack_public_path__ + "static/media/epigro_mobile_1.f4569033.png";